<!-- ? V2 1XP -->

<script lang="ts">
const sizes = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  xLarge: 'xLarge',
};

type Props = {
  color?: string;
  id?: string;
  name: string;
  size?: keyof typeof sizes;
};

const mapping = {
  'shopping-cart': 'shopping_cart',
  envelope: 'mail',
  'user-tie': 'person',
  'question-circle': 'help',
  'info-circle': 'info',
  'exclamation-triangle': 'warning',
  'flaticon-information': 'info',
  clock: 'schedule',
  rocket: 'rocket_launch',
  location: 'location_on',
  home: 'home',
  fax: 'fax',
  'id-card': 'badge',
  'phone-alt': 'call',
  'mobile-alt': 'mobile_2',
  'globe-europe': 'language',
  'globe-americas': 'language',
  qrcode: 'qr_code',
  comments: 'mail',
  wifi: 'sensors',
  'laptop-code': 'computer',
  'tachometer-alt': 'speed',
  'network-wired': 'network_node',
  server: 'dns',
  'comment-dots': 'chat',
  'fa-share-nodes': 'share',
  'fa-share-alt': 'share',
  'fa-envelope': 'mail',
  share: 'share',
};

const getNameMapped = (name: string) =>
  name
    .split(' ')
    .filter((name) => name !== 'fas')
    .map((name) => mapping[name.replace(/^fa-/, '')] ?? name)
    .join(' ');
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<Props>(), {
  size: 'medium',
  name: '',
});

const nameMapped = computed(() => getNameMapped(props.name));
</script>

<template>
  <span
    :id="id"
    :class="['material-symbols-outlined', $style[`size-${sizes[props.size]}`]]"
    :style="{ color: props.color }"
  >
    {{ nameMapped }}
  </span>
</template>

<style module lang="scss">
@forward './Icon.scss';
</style>
